// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_UploadAttributePhotoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/upload_attribute_photo
 *
 * Validates input for uploading a photo for a laudo report attribute.
 * Multipart form: order_item_id + attribute_id (POST fields) + photo (file).
 *
 * Fields:
 *   order_item_id — int, required
 *   attribute_id  — int, required (so_ra_id from so_report_attributes)
 *   _files        — array, required (raw PHP $_FILES superglobal slice)
 */
import { registerContract } from './validate'

export interface Orders_UploadAttributePhotoInput {
order_item_id: number
attribute_id: number
_files: unknown[]
}

registerContract('Orders_UploadAttributePhotoInput', {
  order_item_id: { type: 'number',  required: true },
  attribute_id:  { type: 'number',  required: true },
  _files:        { type: 'array',   required: true },
})
